/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Toggle, ToggleSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import React from 'react';

const ControlledToggle = props => {
  const { id, toggled, disabled, onToggle, instanceLoaded } = props;

  return (
    <>
      {instanceLoaded ? (
        // If field, use a Controlled version.
        <Toggle
          id={id}
          toggled={toggled}
          disabled={disabled}
          onToggle={onToggle}
        />
      ) : (
        <ToggleSkeleton />
      )}
    </>
  );
};

ControlledToggle.propTypes = {
  id: PropTypes.string.isRequired,
  toggled: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  instanceLoaded: PropTypes.bool
};

ControlledToggle.defaultProps = {
  disabled: false,
  toggled: false,
  instanceLoaded: false
};

export { ControlledToggle };
